<template>
  <b-modal id="modal-confirm-delete-menu" header-class="danger">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <TitleModal :tag="'div'" :label="$t('engine.manageHeader.widgetMenu.confirmDeleteMenu.lblTitle', languageEngine)" />
      </div>
      <div
        @click="closeModal()"
        type="button"
        aria-label="Close"
        class="icon-close-modal"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div class="fs-sa-16">
        {{$t('engine.manageHeader.widgetMenu.confirmDeleteMenu.lblDetail', languageEngine)}} <span class="text-danger"> {{item_name}} </span> ?
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="danger" @click="confirm" class="fs-sa-14"><i class="far fa-trash-alt" style="width: 14px; height: 14px; font-size: 14px;"></i> {{$t('engine.manageHeader.widgetMenu.confirmDeleteMenu.lblBtnDelete', languageEngine)}} </b-button>
      <b-button variant="default" @click="closeModal" class="fs-sa-14"> <i class="far fa-times" style="width: 14px; height: 14px; font-size: 14px;"></i> {{$t('engine.manageHeader.widgetMenu.confirmDeleteMenu.lblBtnCancel', languageEngine)}} </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

export default {
  components: {
    TitleModal
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    closeModal() {
      this.$emit('clear');
      this.$bvModal.hide("modal-confirm-delete-menu");
    },
    confirm() {
      this.$emit('confirmed');
      this.$bvModal.hide("modal-confirm-delete-menu");
    }
  },
  props:["id","item_name"]
}
</script>
<style lang="scss">
#modal-confirm-delete-menu {
  .modal-header {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    .icon-close-modal {
      font-size: 24px;
      width: 16px;
      height: 24px;
      color: rgba(0, 0, 0, 0.5);
      svg { 
        position: absolute;
      }
    }
  }
  .modal-body {
    padding: 24px;
    display: flex;
    align-items: center;
  }
  .modal-footer {
    padding: 16px 24px;
    display: flex;
    align-items: center;
  }
}
</style>